import Renderer from './render';
import { IRouteLaunchArguments, ILaunchControllerProps } from './interface';
import { DataCheckResult, IBaseController } from '../interface';

const module: IBaseController<IRouteLaunchArguments, ILaunchControllerProps> = {
    renderer: Renderer,
    canRender: () => Promise.resolve({ hasEnoughDataToRender: true }),
    canLoad: () => Promise.resolve(DataCheckResult.DataAvailableOffline),
};

export default module;
